export const DATA_TEST_IDS = {
  LIST: 'video_wave_mediafiles_editor_list',
  HANDLE: (kind: string, id: string) => `drag-handle_${kind}_mediafile_${id}`,
};
